import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=03d1db67&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ErrorDialog.vue?vue&type=script&lang=js&"
export * from "./ErrorDialog.vue?vue&type=script&lang=js&"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=03d1db67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d1db67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
